// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1WutM","bigColWidth":"Table_bigColWidth__cXHu9","biggerColWidth":"Table_biggerColWidth__auWG_","row":"Table_row__3tFUr","col":"Table_col__2-TAC"};